/**
 * Fetches a video with JWT authorization and returns a blob URL
 * @param {string} videoPath - The video path/URL
 * @param {string} token - JWT authorization token
 * @returns {Promise<string>} - Blob URL for the video
 */
export default async function loadProtectedVideo(videoPath, token) {
    try {
        // Convert /images/ path to /api/images/ for the protected API route
        const apiPath = videoPath.replace('/images/', '/api/images/');

        const response = await fetch(apiPath, {
            headers: {
                'Authorization': token
            }
        });

        if (!response.ok) {
            throw new Error(`Failed to load video: ${response.status}`);
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error loading protected video:', error);
        return '';
    }
}
